// extracted by mini-css-extract-plugin
module.exports = {"SwitchRoot":"styles_SwitchRoot__lV5hG","large":"styles_large__aNPZQ","green":"styles_green__4py4Y","SwitchThumb":"styles_SwitchThumb__6BlQp"};